import {Filter} from 'mc/lib/filter';
import {InfiniteListActions} from 'mc/lib/list';
import ZadostApi from '../api/ZadostApi';

export const ZADOST_LIST_AREA = "zadostList";

export function filterZadosti(filter = {}) {
    return InfiniteListActions.filter(ZADOST_LIST_AREA, filter);
}

export function fetchZadostiIfNeeded(force = false) {
    return InfiniteListActions.fetchIfNeeded(ZADOST_LIST_AREA, null, getZadostiAllIds, getZadostiRowsByIds, force);
}

const getZadostiAllIds = (parent, filter) => {
    const {datumPodani, ...otherFilterFields} = Filter.purifyValues(filter);

    return ZadostApi.findIdsByFilter({
        datumPodaniOd: datumPodani ? datumPodani.datumOd : null,
        datumPodaniDo: datumPodani ? datumPodani.datumDo : null,
        ...otherFilterFields,
    });
};

const getZadostiRowsByIds = (ids) => {
    return ZadostApi.findByIds(ids);
};

export function loadMoreZadosti() {
    return InfiniteListActions.loadMore(ZADOST_LIST_AREA, getZadostiRowsByIds);
}

export function reloadZadosti() {
    return InfiniteListActions.reload(ZADOST_LIST_AREA, null, getZadostiAllIds, getZadostiRowsByIds,);
}